import { Button } from "../../components/Button";
import { Card } from "../../components/Card";
import { REFERRAL_INVITER_BONUS } from "./constants";

export function PromotionsReferralCard({
  loading,
  err,
  link,
  copied,
  onCopy,
}) {
  return (
    <Card
      variant="light"
      className="promotionsPromoCard"
      title="Реферальная ссылка"
      subtitle={`Отправь другу ссылку. Когда он пройдёт все четыре закреплённых шага здесь (ФИО, дата рождения, телефон и подписка на канал), ты получишь +${REFERRAL_INVITER_BONUS} бонусов один раз за этого друга.`}
    >
      {loading ? <p className="muted">Загрузка ссылки…</p> : null}
      {!loading && err ? <p className="errorMessage">{err}</p> : null}
      {!loading && !err && link ? (
        <div className="promotionsReferralRow">
          <label className="field">
            Твоя ссылка
            <input type="text" readOnly value={link} className="promotionsReferralInput" />
          </label>
          <Button type="button" variant="accent" onClick={onCopy}>
            {copied ? "Скопировано" : "Копировать"}
          </Button>
        </div>
      ) : null}
    </Card>
  );
}
